import PickupDaysPill from './pickup-days-pill';
import { parseISO } from 'date-fns';
import { formatDate } from '@/util-conversion/date/format-date';
import { DateFormats } from '@/util-conversion/date/date-formats';
import { cn } from '@/shadcn-ui/utils';

export interface PickupAvailabilityProps {
  pickupDays?: number;
  earliestAvailableDate: string;
  variant?: 'body2' | 'body3' | 'body';
  className?: string;
}

export default function PickupAvailability({
  pickupDays,
  earliestAvailableDate,
  variant = 'body3',
  className,
}: PickupAvailabilityProps) {
  return pickupDays === 0 || pickupDays === 1 ? (
    <PickupDaysPill pickupDays={pickupDays} />
  ) : (
    <>
      {earliestAvailableDate ? (
        <p
          className={cn(
            {
              body3: variant === 'body3',
              body2: variant === 'body2',
              body: variant === 'body',
            },
            className
          )}
        >
          Get it by{' '}
          {formatDate(parseISO(earliestAvailableDate), DateFormats.DISPLAY_ABBR)}
        </p>
      ) : null}
    </>
  );
}
